import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState  } from 'react';
import { Button, Col, Container, Row, Modal, Tooltip  } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BalanceHistory from '../../../components/BalanceHistory'

export type MedicalRetroBalanceModalProps = {
    show: boolean;
    handleClose: () => void;
  };

const balanceHistories = [
  {
    balance: 431.46,
    newCharges: 0.0,
    balanceTotal: 431.46,
    lastPayment: 143.83,
    lastPaymentDate: '09/08/2023',
    outstandingBalance: 287.63,
    approxRemainingPayments: '2',
    reason: 'Past outstanding balance rolled over',
  },
  {
    balance: 575.29,
    newCharges: 0.0,
    balanceTotal: 575.29,
    lastPayment: 143.83,
    lastPaymentDate: '08/25/2023',
    outstandingBalance: 431.46,
    approxRemainingPayments: '3',
    reason: 'Past outstanding balance rolled over',
  },
  {
    balance: 0.0,
    newCharges: 767.06,
    balanceTotal: 767.06,
    lastPayment: 191.77,
    lastPaymentDate: '08/11/2023',
    outstandingBalance: 575.29,
    approxRemainingPayments: '3',
    reason:
      'Coverage changes due to Return from Leave dated 07/31/2023 with changes effective 07/01/2023',
  },
];

  
const MedicalRetroBalanceModal = ({
    show,
    handleClose,
  }: MedicalRetroBalanceModalProps) => {
  const [showMore, setShowMore] = React.useState<boolean>(false);

  const toggleShowMore = (e: any) => {
    setShowMore(!showMore);
  };

  return (
    <>
    <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>Balance History</h5>
            <div className={'row pl-15 pr-15 pt-15 h6 text-fs-6'}>
              <span>
                <b>Medical</b> (Before-Tax)
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={
              'd-none d-sm-none d-lg-flex row pb-5 fb hidden-xs hidden-sm sticky-row border-bottom'
            }
          >
            <div className={'col-sm-1 col-md-1 col-lg-1 w-lg-12 text-fs-6'}>
            <span className="text-nowrap"><b>Balance</b>
              <OverlayTrigger overlay={<Tooltip>Benefit Info</Tooltip>}>
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </span>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-1 w-lg-16 text-fs-6'}>
            <b>New <span className="text-nowrap"> Charges
              <OverlayTrigger overlay={<Tooltip>New Charges Info</Tooltip>}>
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span> 
                )}
              </OverlayTrigger>
              </span>
              </b>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 text-fs-6'}>
              <b>Balance Total</b>
              <OverlayTrigger overlay={<Tooltip>Balance Total Info</Tooltip>}>
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 w-lg-12 text-fs-6'}>
              <b>Last Payment <span className="text-nowrap">Details
              <OverlayTrigger
                overlay={<Tooltip>Last Payment Details Info</Tooltip>}
              >
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
              </span>
              </b>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 text-fs-6'}>
              <b>Outstanding Balance Details</b>
              <OverlayTrigger
                overlay={<Tooltip>Outstanding Balance Info</Tooltip>}
              >
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 w-lg-13 text-fs-6'}>
              <b>Approx Remaining Payments</b>
              <OverlayTrigger
                overlay={<Tooltip>Approx Remaining Payments Info</Tooltip>}
              >
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 w-lg-13'}></div>
          </div>
          {balanceHistories.map((history) => {
            return (
              <BalanceHistory
              {...history} 
              />
            )
          })}
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default MedicalRetroBalanceModal